import { useSyncExternalStore } from 'react';
// Subscribe to a CSS media query. Re-renders when the match state flips.
// SSR / non-browser environments (matchMedia unavailable) return `false`.
export const useMediaQuery = (query) => {
    const subscribe = (onChange) => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return () => { };
        }
        const mql = window.matchMedia(query);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    };
    const getSnapshot = () => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return false;
        }
        return window.matchMedia(query).matches;
    };
    return useSyncExternalStore(subscribe, getSnapshot, () => false);
};
